import { AssetsTranslations } from "../CountryPage";

import firstSectionMobile from "../../../assets/images/DEU/first-section-mobile_DEU.png";
import firstSectionDesktop from "../../../assets/images/DEU/first-section-desktop_DEU.jpg";
import secondSectionMobile from "../../../assets/images/DEU/second-section-mobile_DEU.png";
import secondSectionDesktop from "../../../assets/images/DEU/second-section-desktop_DEU.jpg";
import thirdSectionMobile from "../../../assets/images/DEU/third-section-mobile_DEU.png";
import thirdSectionDesktop from "../../../assets/images/DEU/third-section-desktop_DEU.jpg";
import fourthSectionMobile from "../../../assets/images/DEU/fourth-section-mobile_DEU.jpg";
import fourthSectionDesktop from "../../../assets/images/DEU/fourth-section-desktop_DEU.jpg";

export const germanTranslatedAssets: AssetsTranslations = {
  firstSectionMobile,
  firstSectionDesktop,
  secondSectionMobile,
  secondSectionDesktop,
  thirdSectionMobile,
  thirdSectionDesktop,
  fourthSectionMobile,
  fourthSectionDesktop,
};

export const germanTranslations = {
  "landingPage.selection.title": "Willkommen bei Nelia",
  "landingPage.hero.title":
    "Deine Unterstützung für seltene Nierenerkrankungen",
  "landingPage.hero.body":
    "Ermöglicht dir, informierte Entscheidungen über deine Gesundheit zu treffen",
  "landingPage.usp.ho.label": "Gesundheitsübersicht",
  "landingPage.usp.ho.title": "Verwalte die Veränderungen deiner Gesundheit",
  "landingPage.usp.ho.body":
    "Protokolliere regelmäßig deine Erfahrungen, um Veränderungen deiner Gesundheit zu beobachten. Fühle dich durch aufschlussreiche Diagramme besser informiert und mehr unter Kontrolle in Bezug auf deine Nierenerkrankung.",
  "landingPage.usp.ia.label": "Bleib informiert",
  "landingPage.usp.ia.title": "Hol dir Inhalte, nur für dich",
  "landingPage.usp.ia.body":
    "Erhalte empfohlene Artikel, die dir bei deiner persönlichen Erfahrung helfen könnten, und greife jederzeit und überall darauf zu. Lerne in deinem eigenen Tempo und verbringe extra Zeit mit den Themen, die du für am wichtigsten hältst, um sie besser zu verstehen.",
  "landingPage.usp.si.label": "Setze dich für dich selbst ein",
  "landingPage.usp.si.title": "Fühl dich gestärkt durch Vorbereitung",
  "landingPage.usp.si.body":
    "Registriere dich und bereite dich auf all deine bevorstehenden Termine vor. Nimm aktiv an Gesprächen mit deinem Arzt teil, indem du Notizen mit unseren Themenvorgaben schreibst.",
  "landingPage.usp.cs.label": "Mit Leichtigkeit dokumentieren",
  "landingPage.usp.cs.title": "Halte alle deine Ergebnisse an einem Ort",
  "landingPage.usp.cs.body":
    "Erhalte empfohlene Artikel, die dir bei deiner persönlichen Erfahrung helfen könnten, und greife jederzeit und überall darauf zu. Lerne in deinem eigenen Tempo und verbringe zusätzliche Zeit mit den Themen, die du für am wichtigsten hältst, um sie besser zu verstehen.",
  "landingPage.moreFeatures.title": "...mehr Funktionen und Vorteile von Nelia",
  "landingPage.moreFeatures.feel.title": "Bleib auf Kurs mit deiner Behandlung",
  "landingPage.moreFeatures.feel.body":
    "Erhalte Unterstützung bei deinen Medikamentenplänen und erhalte Erinnerungen genau dann, wenn du sie brauchst. Diese Funktion kommt bald.",
  "landingPage.moreFeatures.discover.title":
    "Werkzeuge, die dir helfen, dich im Alltag organisierter zu fühlen",
  "landingPage.moreFeatures.discover.body":
    "Passe deine Benachrichtigungen an einen Zeitplan an, der dir am besten passt.",
  "landingPage.moreFeatures.tools.title":
    "Entdecke ein intuitives und einfach zu bedienendes Design",
  "landingPage.moreFeatures.tools.body":
    "Erlebe eine intuitive und benutzerfreundliche Oberfläche, die sich einfach navigieren lässt.",
  "landingPage.footer.privacyPolicy": "Datenschutzrichtlinie",
  "landingPage.footer.licenses": "Lizenzen",
  "landingPage.download.title": "Lade Nelia jetzt herunter",
};
